// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomDropdown.css */
.custom-dropdown {
  position: relative;
  width: 220px;
  font-size: 16px;
  cursor: pointer;
}

.custom-dropdown-control {
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-dropdown-arrow {
  margin-left: 8px;
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 800px;
  overflow-y: auto;
}

.custom-dropdown-search {
  width: 80%;
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid #ccc;
  outline: none;
}

.custom-dropdown-options {
  max-height: 150px;
  overflow-y: auto;
}

.custom-dropdown-option {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}

.custom-dropdown-option:hover {
  background-color: #f2f2f2;
}

.custom-dropdown-no-options {
  padding: 8px 12px;
  color: #888;
}

/* Dark Mode Overrides */
body.dark-mode .custom-dropdown-control {
  background-color: #000;
  color: #fff;
}

body.dark-mode .custom-dropdown-menu {
  background-color: #000;
  color: #fff;
}

body.dark-mode .custom-dropdown-option {
  color: #fff;
}

body.dark-mode .custom-dropdown-option:hover {
  background-color: #333;
}

/* Additional Dark Mode Override for dropdown search */
body.dark-mode .custom-dropdown-search {
  background-color: #000;
  color: #fff;
  border-bottom: 1px solid #444;
} `, "",{"version":3,"sources":["webpack://./src/components/CustomDropdown.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B","sourcesContent":["/* CustomDropdown.css */\n.custom-dropdown {\n  position: relative;\n  width: 220px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.custom-dropdown-control {\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  border-radius: 4px;\n  background-color: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.custom-dropdown-arrow {\n  margin-left: 8px;\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  max-height: 800px;\n  overflow-y: auto;\n}\n\n.custom-dropdown-search {\n  width: 80%;\n  padding: 8px 12px;\n  border: none;\n  border-bottom: 1px solid #ccc;\n  outline: none;\n}\n\n.custom-dropdown-options {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.custom-dropdown-option {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n}\n\n.custom-dropdown-option:hover {\n  background-color: #f2f2f2;\n}\n\n.custom-dropdown-no-options {\n  padding: 8px 12px;\n  color: #888;\n}\n\n/* Dark Mode Overrides */\nbody.dark-mode .custom-dropdown-control {\n  background-color: #000;\n  color: #fff;\n}\n\nbody.dark-mode .custom-dropdown-menu {\n  background-color: #000;\n  color: #fff;\n}\n\nbody.dark-mode .custom-dropdown-option {\n  color: #fff;\n}\n\nbody.dark-mode .custom-dropdown-option:hover {\n  background-color: #333;\n}\n\n/* Additional Dark Mode Override for dropdown search */\nbody.dark-mode .custom-dropdown-search {\n  background-color: #000;\n  color: #fff;\n  border-bottom: 1px solid #444;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
